
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ClueService } from '@/services'
import ReportedDialog from './components/reportedDialog.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'ClueReported',
    components: {
        ReportedDialog,
        ScrollTo
    }
})
export default class extends Vue {
    private pageIndex = 1
    private pageSize = 15
    private pageTotal = 0
    private clueList = []
    private isLoading = true
    private curClue: any = ''
    @Ref('reportDialog') private reportDialog: any
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private mounted() {
        this.getClues()
    }

    private async getClues() {
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.isLoading = true
        const result = await ClueService.getClueReported(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.clueList = result.data.list
        }
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getClues)
    }

    private onDelete(id: number) {
        this.$confirm('是否确定删除此已报道的线索?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let result = await this.deleteClue(id)
            result && (await this.getClues())
            this.isLoading = false
        })
    }

    private async deleteClue(id: number) {
        const params = { id }
        const result = await ClueService.deleteClueReported(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '删除成功'
            })
            return true
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 删除失败',
            showClose: true
        })
        return false
    }

    private onUpdate(clue: any) {
        console.log('clue.url', clue)
        this.curClue = {
            ...clue,
            title: clue.clue.title,
            media: clue.medium_name,
            time: clue.published_at
        }
        this.reportDialog.show()
    }

    private async updateClueReport(clue: any) {
        const params = { ...clue, clue_id: this.curClue.clue.id }
        const result = await ClueService.updateClueReported(params)
        if (result.status === 200) {
            this.curClue.medium_name = clue.medium_name
            this.curClue.published_at = clue.published_at
            this.curClue.updated_at = clue.published_at
            this.curClue.url = clue.url
            this.reportDialog.hide()
            return this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 修改失败',
            showClose: true
        })
    }
}
